export default {
  title: '操作ログ一覧',
  list: {
    id: 'ID',
    tripId: 'Trip ID',
    event: '操作',
    auditableType: '対象',
    auditableId: '対象ID',
    ipAddress: 'IPアドレス',
    createdAt: '実行日',
    operatedUserName: 'アカウント名',
    operatedUserId: 'アカウントID',
  },
  auditableType: {
    delivery_plan_work: '日報 作業',
    workload: '日報 荷物量・給油量',
    vehicle: '車両',
    account: 'アカウント',
    spot: '地点',
    operationOffice: '運営会社',
    reportLayout: '日報プリセット',
  },
  event: {
    created: '作成',
    updated: '更新',
    deleted: '削除',
  },
  openNewWindow: {
    account: 'アカウント編集画面を開く',
    spots: '地点一覧画面を開く',
    operationOffice: '運営会社編集画面を開く',
    reportLayouts: '日報プリセット一覧画面を開く',
    dailyReports: '日報出力画面を開く', 
    vehicle: '車両編集画面を開く',
  }
}
